import { useUserStore } from '@store/app.store';
import { usePeopleOptions } from '@services/query-services/people.query-service';
import CustomSelect from '@components/general/form/custom-select.component';
import FocusFormField from '@components/focus/focus-form-field.component';
import { Center, HStack, Icon, Switch, Text, Tooltip } from '@chakra-ui/react';
import { QuestionIcon } from '@assets/icons';
import { forwardRef } from 'react';

export default function FocusEditFollowers({
  value,
  onChange,
  isEdit,
  isBulkRemapChecked,
  setIsBulkRemapChecked,
  allowBulkRemap = true,
  ...selectProps
}) {
  const user = useUserStore((state) => state.user);
  const { data: peopleOptions } = usePeopleOptions({ not_types: ['Associate'], active: true });

  const filteredPeopleOptions = isEdit
    ? peopleOptions
    : peopleOptions?.filter((p) => p?.value !== user?.id);

  return (
    <FocusFormField label='Followers'>
      <CustomSelect
        placeholder='Add colleagues...'
        options={filteredPeopleOptions}
        onChange={onChange}
        value={value}
        {...selectProps}
      />
      {allowBulkRemap && (
        <HStack
          gap={3}
          mt={2}
        >
          <Switch
            isChecked={isBulkRemapChecked}
            onChange={(e) => setIsBulkRemapChecked(e.target.checked)}
          />
          <Text fontWeight={600}>Re-map any matching existing meetings to this category</Text>
          <Tooltip label='If this is on, when a category is created, Fora will attempt to re-match the category of every future meeting currently on your agenda'>
            <HelpIcon />
          </Tooltip>
        </HStack>
      )}
    </FocusFormField>
  );
}

const HelpIcon = forwardRef(({ ...rest }, ref) => (
  <Center
    ref={ref}
    border='1px solid'
    color='surface.onSurfaceVariant'
    boxSize={3.5}
    rounded='full'
  >
    <Icon
      as={QuestionIcon}
      boxSize={2.5}
      {...rest}
    />
  </Center>
));
